// extracted by mini-css-extract-plugin
export default {"testimonial":"testimonial_testimonial__Pg6Wz"};